import { useState, useMemo } from 'react';
import { fetchPCConsoleCompareTableResultsPlus } from '../services';
import { getGameId, analyseGamesMetricsData } from '../utils';
import type {
  IFilter,
  IPCConsoleGame,
  IRegionValueDataOfRegionSelector,
  IPCConsoleGamesCompareTableResult,
} from '@/pages/intelligence/types/pcConsoleCompare';

export default function useCompareTables(option: {
  entityTypes?: string[];
  // 阶段
  periods: string[];
  // 所有的devices
  devices: string[];
  // 筛选器数据
  filter: IFilter;
  // Physical Revenue页面 会传自定义的请求方法进来
  fetchCompareTableResults?: (params: {
    games: IPCConsoleGame[];
    metrics: string[];
    devices?: string[];
    segments?: string[];
    regionData?: IRegionValueDataOfRegionSelector;
    isShowTop3Countries?: boolean;
  }) => Promise<{
    compare_list: IPCConsoleGamesCompareTableResult[];
  }>;
}) {
  const { entityTypes, periods, devices, filter, fetchCompareTableResults } = option || {};

  const fetcher =
    typeof fetchCompareTableResults === 'function' ? fetchCompareTableResults : fetchPCConsoleCompareTableResultsPlus;

  const [isLoading, setIsLoading] = useState(true);

  const [compareResult, setCompareResult] = useState<IPCConsoleGamesCompareTableResult[]>([]);

  const compareTableData = useMemo<{
    games: IPCConsoleGame[];
    tablesMetricsMap: {
      [key: string]: any;
    };
    tablesPeriodMaxMetricsMap: {
      [key: string]: any;
    };
  }>(() => {
    const gamesMetricsCompareData = analyseGamesMetricsData(compareResult, {
      periods,
      metrics: filter?.metrics,
    });
    return {
      games: gamesMetricsCompareData?.entities || [],
      tablesMetricsMap: gamesMetricsCompareData?.metricsMap || {},
      tablesPeriodMaxMetricsMap: gamesMetricsCompareData?.periodMaxMetricsMap || {},
    };
  }, [compareResult, periods, filter?.metrics]);

  const updateCompareTableData = async (params?: { games?: IPCConsoleGame[]; filter?: IFilter; callback?: (res: any) => void; }): Promise<void> => {
    setIsLoading?.(true);
    const gamesTemp = params?.games || compareTableData?.games || [];
    const filterTemp = params?.filter || filter;
    const res = await fetcher?.(
      {
        entityTypes,
        games: gamesTemp,
        metrics: filterTemp?.metrics,
        devices: filterTemp?.devices,
        segments: filterTemp?.segments,
        regionData: filterTemp?.regionData,
        isShowTop3Countries: filterTemp?.isShowTop3Countries,
      },
      { devices },
    );
    setCompareResult(res?.compare_list || []);
    setIsLoading?.(false);
    if (typeof params?.callback === 'function') {
      const gamesMetricsCompareData = analyseGamesMetricsData(res?.compare_list, {
        periods,
        metrics: filter?.metrics,
      });
      params?.callback?.(gamesMetricsCompareData?.entities || []);
    }
  };

  const handleDeleteGames = (ids: string[]) => {
    const compareResultTemp = compareResult?.filter((item) => !ids?.includes(getGameId(item))) || [];
    setCompareResult(compareResultTemp);
  };

  return {
    isLoading,
    setIsLoading,
    compareTableData,
    updateCompareTableData,
    onDeleteGames: handleDeleteGames,
  };
}
